import './About.scss'
import './AboutTextBlock.scss'
import type { ReactNode } from 'react'
import { StructuredText } from 'react-datocms'
import { StructuredData } from '#src/components/StructuredData.js'
import { fetchPageMeta } from '#src/data/data.js'
import { languageService } from '#src/languageService.js'
import { getAboutPageData } from '#src/pages/about-us/aboutData.js'
import { mergeMeta } from '#src/seo.js'
import type { Route } from './+types/about-us.route.js'

export async function loader({ request }: Route.LoaderArgs) {
  const lang = languageService.langFromRequest(request)
  const [data, meta] = await Promise.all([
    getAboutPageData(lang),
    fetchPageMeta('aboutPage', lang, '/about-us'),
  ])
  return { data, meta }
}

export function meta({ loaderData, matches }: Route.MetaArgs): Route.MetaDescriptors {
  return mergeMeta(matches[0].meta, loaderData?.meta || [])
}

export default function About({ loaderData }: Route.ComponentProps): ReactNode {
  const { data } = loaderData

  return (
    <section className="about">
      {data.blocks.map(block => (
        <div className="about__text-container" key={block.id}>
          <StructuredText data={block.content} />
        </div>
      ))}
      {data.structuredData && <StructuredData data={data.structuredData} />}
    </section>
  )
}
